enum JobEvenMessage {
  IMPORTED = 'JobDataImported',
  PROCESSED = 'JobDataProcessed',
  NO_DATA = 'JobNoDataFound',
}

export default JobEvenMessage;
